import { useQueryClient } from "@tanstack/react-query";
import { useCallback, useRef, useState } from "react";
import { getNookClient } from "../client.js";
import { NookApiError } from "../http.js";
import { queryKeys } from "../query-keys.js";
export function useAskStream() {
    const queryClient = useQueryClient();
    const controller = useRef(null);
    const [events, setEvents] = useState([]);
    const [status, setStatus] = useState("idle");
    const start = useCallback(async (request) => {
        controller.current?.abort();
        const current = new AbortController();
        controller.current = current;
        setEvents([]);
        setStatus("streaming");
        let threadId = request.threadId;
        let ended = null;
        try {
            for await (const event of getNookClient().ask(request, current.signal)) {
                if (event.type === "turn")
                    threadId = event.threadId;
                if (event.type === "turn" || event.type === "title" || event.type === "done") {
                    void queryClient.invalidateQueries({ queryKey: queryKeys.ask.threads() });
                }
                setEvents((previous) => [...previous, event]);
                if (event.type === "done" || event.type === "error")
                    setStatus((ended = event.type));
            }
            // A stream that ends without `done` or `error` failed after it opened —
            // unless it was stopped and the transport closed it rather than throwing.
            if (current.signal.aborted)
                return "cancelled";
            if (!ended)
                setStatus("error");
            return ended ?? "error";
        }
        catch (err) {
            if (current.signal.aborted)
                return "cancelled";
            setEvents((previous) => [
                ...previous,
                {
                    type: "error",
                    code: err instanceof NookApiError ? err.code : "network_error",
                    message: err instanceof Error ? err.message : "Ask is unavailable right now.",
                },
            ]);
            setStatus("error");
            return "error";
        }
        finally {
            if (threadId)
                void queryClient.invalidateQueries({ queryKey: queryKeys.ask.thread(threadId) });
        }
    }, [queryClient]);
    const cancel = useCallback(() => {
        controller.current?.abort();
        setStatus("cancelled");
    }, []);
    return { start, events, status, cancel };
}
//# sourceMappingURL=use-ask-stream.js.map